require('./brokerRequestFinancialOperationChangeSuccess.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { formatCurrency, formatAmount } = require('utilities/currencyHelper');
const { withRouter } = require('react-router-dom');

// @components
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @constants
const RETURN_TO_CORPORATES_OPERATIONS_LINK = '/myprofile/broker/corporatesOperations';
const GO_TO_MY_WALLET_URL = '/myprofile/broker/general';

// @constants
const { CHARGE_ACCOUNT_PREFIX, FIRST_STEP, DATE_FORMAT_ES } = require('constants/index');


class BrokerRequestFinancialOperationChangeSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.buildHeader = this.buildHeader.bind(this);
        this.buildField = this.buildField.bind(this);
        this.buildLeftColumnDetails = this.buildLeftColumnDetails.bind(this);
        this.buildRightColumnDetails = this.buildRightColumnDetails.bind(this);
        this.buildFooter = this.buildFooter.bind(this);
        this.handleGoToCorporatesOperation = this.handleGoToCorporatesOperation.bind(this);
    }

    buildField(primaryText, secondaryText, description = <span>&nbsp;</span>) {
        return (
            <div className="broker-request-financial-operation-change-success__details-field">
                <h5 className="broker-request-financial-operation-change-success__details-primary-text">
                    <FormattedText
                        value={primaryText}
                        format="uppercase"
                    />
                </h5>
                <div className="broker-request-financial-operation-change-success__details-secondary-text">
                    {secondaryText}
                </div>
                <div className="broker-request-financial-operation-change-success__details-gray">
                    {description}
                </div>
            </div>
        );
    }

    handleGoToCorporatesOperation() {
        this.props.history.push(RETURN_TO_CORPORATES_OPERATIONS_LINK);
    }

    buildFooter() {
        return (
            <div>
                <div className="wizard-success-step__separator" />
                <div className="wizard-success-step__foot-buttons text-right">
                    <span className="broker-request-financial-operation-change-success__corporates-operations-button">
                        <OKButton
                            modifier="ghost"
                            onClick={this.handleGoToCorporatesOperation}
                        >
                            <FormattedText value="requestFinancialOperationChange-returnToCorporateOperations" />
                        </OKButton>
                    </span>
                    <OKButton
                        modifier="secondary"
                        to={GO_TO_MY_WALLET_URL}
                    >
                        <FormattedText value="requestFinancialOperationChange-goToMyWallet" />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildHeader() {
        const { immBrokerRequestFinancialOperationChange } = this.props;
        const orderNumber = immBrokerRequestFinancialOperationChange.get('orderNumber');

        return (
            <div className="wizard-success-step__highlight">
                <i className="wizard-success-step__success-icon" />
                <div className="wizard-success-step__messages">
                    <OKBoxTitle
                        value={formatText('requestFinancialOperationChange-successTitle')}>
                        <div className="wizard-success-step__success-sub-message">
                            <FormattedText
                                value="requestFinancialOperationChange-successSubtitle"
                                injectedStrings={[orderNumber]}
                            />
                        </div>
                    </OKBoxTitle>
                </div>
            </div>
        );
    }

    buildLeftColumnDetails() {
        const { immBrokerRequestFinancialOperationChange } = this.props;
        const immContrato = immBrokerRequestFinancialOperationChange.get('contrato');
        const immCuentaAsociada = immBrokerRequestFinancialOperationChange.get('cuentaAsociada');
        const contract = immBrokerRequestFinancialOperationChange.get('contract');
        const contractId = CHARGE_ACCOUNT_PREFIX + immContrato.get('product') + immContrato.get('number');

        const contractNumberText = (
            <FormattedText
                value="requestFinancialOperationChange-contractNumber"
                injectedStrings={[contractId]}
            />
        );
        const contractOwnerText = (
            <FormattedText
                value="requestFinancialOperationChange-contractOwnerName"
                injectedStrings={[immBrokerRequestFinancialOperationChange.get('contractOwner')]}
            />
        );

        const associatedAccountText = (
            <FormattedText
                value="requestFinancialOperationChange-associatedAccountId"
                injectedStrings={[immCuentaAsociada.get('number')]}
            />
        );

        const associatedAccountBalanceText = (
            <FormattedText
                value="requestFinancialOperationChange-associatedAccountBalanceAmount"
                injectedStrings={[formatAmount(immCuentaAsociada.getIn(['balance', 'amount'])), formatCurrency(immCuentaAsociada.getIn(['balance', 'currency']))]}
            />
        );

        const contractField = this.buildField('requestFinancialOperationChange-contract', contract);

        return (
            <div className="broker-request-financial-operation-change-success__details-section-left">
                {contractField}
                <div className="broker-request-financial-operation-change-success__details-gray">
                    <div className="broker-request-financial-operation-change-success__details-field">
                        {contractNumberText}
                        <br />
                        ({contractOwnerText})
                    </div>
                    <div>
                        {associatedAccountText}
                        <br />
                        ({associatedAccountBalanceText})
                    </div>
                </div>
            </div>
        );
    }

    buildRightColumnDetails() {
        const { immBrokerRequestFinancialOperationChange } = this.props;
        const immValor = immBrokerRequestFinancialOperationChange.get('valor');
        const date = DateHelper.buildFormattedDate(immValor.get('endDate'), DATE_FORMAT_ES);
        const titlesNumber = immBrokerRequestFinancialOperationChange.getIn(['steps', FIRST_STEP, 'titlesAmount']);
        const dateField = this.buildField('broker-rightsBuySidebarDeadlineLabel', date);
        const titleNumberField = this.buildField('requestFinancialOperationChange-titleNumber', titlesNumber);

        return (
            <div className="broker-request-financial-operation-change-success__details-section-right">
                {dateField}
                {titleNumberField}
            </div>
        );
    }

    render() {
        return (
            <ContentBox>
                {this.buildHeader()}
                <div className="row broker-request-financial-operation-change-success__details-container">
                    <div className="col-xs-4">
                        {this.buildLeftColumnDetails()}
                    </div>
                    <div className="col-xs-8">
                        {this.buildRightColumnDetails()}
                    </div>
                </div>
                {this.buildFooter()}
            </ContentBox>
        );
    }
}

BrokerRequestFinancialOperationChangeSuccess.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerRequestFinancialOperationChange: PropTypes.object.isRequired
};

module.exports = withRouter(BrokerRequestFinancialOperationChangeSuccess);
